"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveBox = void 0;

var _proportionalScale = require("proportional-scale");

var _react = _interopRequireDefault(require("react"));

var _Box = require("../Box");

var _excluded = ["aspectWidth", "aspectHeight"],
    _excluded2 = ["aspectWidth", "aspectHeight", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var responsiveScale = function responsiveScale(args) {
  if ("maxWidth" in args && args.maxWidth === "100%") {
    return {
      maxWidth: "100%",
      paddingBottom: (0, _proportionalScale.paddingBottom)({
        width: args.aspectWidth,
        height: args.aspectHeight
      })
    };
  }

  var width = args.aspectWidth,
      height = args.aspectHeight,
      rest = _objectWithoutProperties(args, _excluded);

  var scaled = (0, _proportionalScale.scale)(_objectSpread({
    width: width,
    height: height
  }, rest));
  return {
    maxWidth: "".concat(scaled.width, "px"),
    paddingBottom: scaled.paddingBottom
  };
};
/** ResponsiveBoxProps */


/** ResponsiveBox */
var ResponsiveBox = function ResponsiveBox(_ref) {
  var aspectWidth = _ref.aspectWidth,
      aspectHeight = _ref.aspectHeight,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded2);

  var scaled = responsiveScale(_objectSpread({
    aspectHeight: aspectHeight,
    aspectWidth: aspectWidth
  }, rest));
  return /*#__PURE__*/_react.default.createElement(_Box.Box, _extends({
    position: "relative",
    width: "100%",
    style: {
      maxWidth: scaled.maxWidth
    }
  }, rest), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    position: "relative",
    width: "100%",
    height: 0,
    overflow: "hidden",
    style: {
      paddingBottom: scaled.paddingBottom
    }
  }), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%"
  }, children));
};

exports.ResponsiveBox = ResponsiveBox;
ResponsiveBox.displayName = "ResponsiveBox";
ResponsiveBox.displayName = "ResponsiveBox";
//# sourceMappingURL=ResponsiveBox.js.map